import InputForm from "../input/input-form.jsx";
import React, {useEffect, useState} from "react";
import ModalBody from "../modal/modal-body.jsx";
import TreeLanes from "./components/tree-lanes.jsx";
import ModalFooter from "../modal/modal-footer.jsx";
import Button from "../button/button.jsx";
import {Modal} from "../modal/modal.jsx";
import {useGlobalKey} from "../../hooks/use-global-key.js";

/***
 Estados da implementação:
     const [treeLaneCheckedStatus, setTreeLaneCheckedStatus] = useState({});
     const [showModal, setShowModal] = useState(false);
     const {
         nodes,
         checkedInitialState,
         isLoading,
         inputCamerasValue
     } = useCapturePlacesTree(capturePlaceService, treeLaneCheckedStatus);

     useEffect(() => {
     if (!nodes.length || Object.keys(treeLaneCheckedStatus).length > 0) return;
     setTreeLaneCheckedStatus(checkedInitialState);
     }, [nodes, checkedInitialState, treeLaneCheckedStatus]);
 ________________________________________________________________________________________________
 Utilização:
     <TreeLanesInput treeLaneCheckedStatus={treeLaneCheckedStatus}
     setTreeLaneCheckedStatus={setTreeLaneCheckedStatus}
     inputCamerasValue={inputCamerasValue}
     showModal={showModal} setShowModal={setShowModal}
     nodes={nodes}
     className=""/>
 ***/
const TreeLanesInput = ({treeLaneCheckedStatus, setTreeLaneCheckedStatus, inputCamerasValue, nodes, className, disabled, showFilter = true, buttonLabel = "Ok", title = "Selecione as câmeras", showModal, setShowModal}) => {
    const [state, setState] = useState("")
    const [nodesToShow, setNodesToShow] = useState({})
    const [localCheckedStatus, setLocalCheckedStatus] = useState(treeLaneCheckedStatus);

    useEffect(() => {
        if (showModal) {
            setLocalCheckedStatus(treeLaneCheckedStatus);
        }
    }, [showModal, treeLaneCheckedStatus]);
    const onChange = ({target: {value}}) => {
        setState(value);
    }
    const searchModal = () => {
        const newNodes = nodes.filter(el => {
            if (!el.label) return

            return el.label.toLowerCase().includes(state.toLowerCase())
        })

        setNodesToShow(newNodes)
    }

    const clearFilter = () => {
        setState("")
        setNodesToShow(nodes)
    }
    const closeModal = () => {
        setShowModal(false);

        setTimeout(() => {
            if (document.activeElement instanceof HTMLElement) {
                document.activeElement.blur();
            }
        }, 0);
    };

    const openModal = () => {
      if(disabled) return;
      setShowModal(true)
  }

    const handleSave = () => {
        setTreeLaneCheckedStatus(localCheckedStatus);
        closeModal();
    }

    useEffect(() => {
        setNodesToShow(nodes)
    }, [nodes]);

    useGlobalKey("Enter", searchModal)
    useGlobalKey("Escape", clearFilter)
    return(
        <>
            <div className={className} onClick={openModal}>
                <InputForm readOnly labelClass={[disabled ? "cursor-default!" : "!bg-white cursor-pointer"].join(" ")} inputClass={[disabled ? "cursor-default!" : "!bg-white pointer-events-none"].join(" ")} label="Câmeras *" value={inputCamerasValue} disabled={disabled}/>
            </div>
            <Modal open={showModal} setOpen={closeModal} title={title} className="w-5/12" isCloseClick={false}>
                <ModalBody>
                    <TreeLanes checked={localCheckedStatus} setChecked={setLocalCheckedStatus} showFilter={showFilter}
                               nodesToShow={nodesToShow} clearFilter={clearFilter} search={searchModal} onChange={onChange} state={state}/>
                </ModalBody>
                <ModalFooter>
                    <Button onClick={handleSave}>{buttonLabel}</Button>
                </ModalFooter>
            </Modal>
        </>
    )
}

export default TreeLanesInput;